'use client'

import { createContext, ReactNode, useContext, useState } from 'react'

const SidebarContext = createContext<{
  isOpen: boolean
  setIsOpen: (open: boolean) => void
  isMobileOpen: boolean
  setMobileOpen: (open: boolean) => void
}>({
  isOpen: false,
  setIsOpen: () => {},
  isMobileOpen: false,
  setMobileOpen: () => {},
})

export const useSidebar = () => useContext(SidebarContext)

export function ContentSidebarProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(true)
  const [isMobileOpen, setMobileOpen] = useState(false)

  return (
    <SidebarContext.Provider value={{ isOpen, setIsOpen, isMobileOpen, setMobileOpen }}>
      {children}
    </SidebarContext.Provider>
  )
}

export default function ContentLayoutClient({
  children,
  hideNavigation,
}: {
  children: ReactNode
  hideNavigation?: boolean
}) {
  const { isOpen } = useSidebar()

  return (
    <div
      className={`grid h-full min-h-0 grid-cols-1 col-span-2 overflow-hidden relative transition-all duration-300 in-iframe:h-auto in-iframe:min-h-fit in-iframe:overflow-visible ${isOpen && !hideNavigation ? 'lg:pr-72' : ''}`}
    >
      {children}
    </div>
  )
}
